import { gql } from '@apollo/client';

export const DocumentFragment = gql`
  fragment documentFragment on Document {
    id
    key
    type
    totalPages
    downloadURL
    individualPages {
      downloadURL
      pageLabel
      pagesPreview {
        urls {
          url
          quality
        }
        width
        height
      }
    }
  }
`;
